  (function () {
    'use strict';

    function readConfig() {
      var node = document.querySelector('[data-cart-drawer-config]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent);
      } catch (err) {
        console.error('[CartDrawer] Invalid config', err);
        return {};
      }
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeAttr(value) {
      return escapeHtml(value);
    }

    function tmpl(template, value) {
      if (!template) return '';
      return String(template)
        .replace('[heading]', value || '')
        .replace('[amount]', value || '');
    }

    function formatMoney(cents) {
      var settings = window.__ornixSettings || {};
      var showCodes = settings.showCurrencyCodes;
      var format = showCodes
        ? (settings.moneyWithCurrencyFormat || '{{amount}}')
        : (settings.moneyFormat || '{{amount}}');

      var amount = Number(cents || 0) / 100;
      var price = amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      var priceNoDecimals = Math.floor(amount).toLocaleString('en-US');

      var result = format
        .replace(/\{\{?\s*amount\s*\}?\}/g, price)
        .replace(/\{\{?\s*amount_no_decimals\s*\}?\}/g, priceNoDecimals)
        .replace(/\{\{?\s*amount_with_comma_separator\s*\}?\}/g, price.replace('.', ','))
        .replace(/\{\{?\s*amount_no_decimals_with_comma_separator\s*\}?\}/g, priceNoDecimals.replace(/,/g, '.'));

      if (!showCodes) {
        result = result.replace(/\s*[A-Z]{3}\s*$/g, '').replace(/^\s*[A-Z]{3}\s*/g, '');
      }

      return result.trim();
    }

    function toCents(value) {
      var cents = Number(value || 0);
      return Number.isFinite(cents) ? cents : 0;
    }

    function getCompareAtUnitPrice(item) {
      var finalPrice = toCents(item.final_price || item.price);
      var compareAtPrice = Math.max(
        toCents(item.original_price),
        toCents(item.compare_at_price),
        toCents(item._compareAtPrice)
      );

      if (compareAtPrice > finalPrice) {
        return compareAtPrice;
      }

      return 0;
    }

    function getCompareAtLinePrice(item) {
      var compareAtLinePrice = Math.max(
        toCents(item.original_line_price),
        toCents(item.compare_at_line_price),
        toCents(item._compareAtLinePrice)
      );
      var finalLinePrice = toCents(item.final_line_price || item.line_price);

      if (compareAtLinePrice > finalLinePrice) {
        return compareAtLinePrice;
      }

      var compareAtUnitPrice = getCompareAtUnitPrice(item);
      if (!compareAtUnitPrice) return 0;

      return compareAtUnitPrice * Math.max(1, Number(item.quantity || 1));
    }

    async function enrichCartItemsWithCompareAt(cart, state) {
      if (!cart || !Array.isArray(cart.items) || !state) return cart;

      await Promise.all(cart.items.map(async function (item) {
        if (getCompareAtUnitPrice(item) > 0) return;

        var variantId = item.variant_id || item.id;
        if (!variantId) return;

        try {
          var variant = state.variantCache[variantId];
          if (typeof variant === 'undefined') {
            var response = await fetch(window.Shopify.routes.root + 'variants/' + variantId + '.js');
            variant = response.ok ? await response.json() : null;
            state.variantCache[variantId] = variant;
          }

          if (!variant) return;
          var compareAtPrice = toCents(variant.compare_at_price);

          var finalPrice = toCents(item.final_price || item.price);
          if (compareAtPrice > finalPrice) {
            item._compareAtPrice = compareAtPrice;
            item._compareAtLinePrice = compareAtPrice * Math.max(1, Number(item.quantity || 1));
          }
        } catch (err) {
          console.error('[CartDrawer compare-at]', err);
        }
      }));

      return cart;
    }

    function renderItemImage(item, heading, itemUrl) {
      var image = item.featured_image || item.image;
      var src = (image && (image.url || image.src)) || item.image;
      if (!src) return '';
      var alt = (image && image.alt) || heading;
      return (
        '<div class="drawer-item__image-wrap">' +
          '<a href="' + escapeAttr(itemUrl) + '" class="drawer-item__image-link" aria-hidden="true" tabindex="-1">' +
            '<img src="' + escapeAttr(src) + '" alt="' + escapeAttr(alt) + '" class="drawer-item__image" loading="lazy" width="300" height="300">' +
          '</a>' +
          '<div class="drawer-item__spinner" aria-hidden="true">' +
            '<svg class="drawer-item__spinner-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">' +
              '<path d="M12 2a10 10 0 0 1 10 10" />' +
            '</svg>' +
          '</div>' +
        '</div>'
      );
    }

    function renderProperties(properties) {
      if (!properties) return '';
      var entries = Object.entries(properties).filter(function (pair) {
        return pair[1] && pair[0] && pair[0].charAt(0) !== '_';
      });
      if (!entries.length) return '';
      var items = entries.map(function (pair) {
        var key = pair[0];
        var val = String(pair[1]);
        var renderedValue = val.includes('/uploads/')
          ? '<a href="' + escapeAttr(val) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(val.split('/').pop()) + '</a>'
          : escapeHtml(val);
        return (
          '<li class="drawer-item__property">' +
            '<span class="drawer-item__property-key">' + escapeHtml(key) + ':</span>' +
            '<span class="drawer-item__property-value">' + renderedValue + '</span>' +
          '</li>'
        );
      }).join('');
      return '<ul class="drawer-item__properties list-unstyled">' + items + '</ul>';
    }

    function renderCartItem(item, index, config) {
      var heading   = item.product_title || item.heading || '';
      var itemUrl = item.url || '#';
      var isMcFreeGift = !!(item.properties && item.properties._mc_free_gift);
      var mcGiftBadgeHtml = isMcFreeGift ? '<span class="mc-cart-gift-badge">Complimentary Gift</span>' : '';

      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="drawer-item__variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';

      var sellingPlanHtml = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)
        ? '<p class="drawer-item__selling-plan">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</p>'
        : '';

      var vendorName = item.vendor || (config.vendorMap && config.vendorMap[String(item.variant_id || item.id)]) || '';
      var vendorHtml = (config.showVendor && vendorName)
        ? '<p class="drawer-item__vendor">' + escapeHtml(vendorName) + '</p>'
        : '';

      var compareAtLinePrice = getCompareAtLinePrice(item);
      var finalLinePrice = toCents(item.final_line_price);
      var unitPrice = toCents(item.final_price || item.price);
      var compareHtml = (compareAtLinePrice > finalLinePrice)
        ? '<span class="drawer-item__price drawer-item__price--compare"><span class="visually-hidden">Original price</span>' + formatMoney(compareAtLinePrice, config) + '</span>'
        : '';

      var priceClass = 'drawer-item__price' + (compareAtLinePrice > finalLinePrice ? ' drawer-item__price--sale' : '');

      var removeLabel   = tmpl(config.removeItemTemplate, heading);
      var quantityLabel = tmpl(config.quantityLabel, heading) || 'Quantity';
      var decreaseLabel = tmpl(config.decreaseQuantityTemplate, heading);
      var increaseLabel = tmpl(config.increaseQuantityTemplate, heading);

      return (
        '<li class="cart-drawer__item drawer-item" id="drawer-item-' + (index + 1) + '" data-cart-item data-item-key="' + escapeAttr(item.key) + '">' +
          renderItemImage(item, heading, itemUrl) +
          '<div class="drawer-item__info">' +
            '<div class="drawer-item__top">' +
              '<a href="' + escapeAttr(itemUrl) + '" class="drawer-item__title">' + escapeHtml(heading) + '</a>' + mcGiftBadgeHtml +
              '<button type="button" class="drawer-item__remove" aria-label="' + escapeAttr(removeLabel) + '" data-cart-remove data-item-key="' + escapeAttr(item.key) + '">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>' +
              '</button>' +
            '</div>' +
            '<p class="drawer-item__unit-price">' + formatMoney(unitPrice, config) + '</p>' +            
            vendorHtml +
            variantHtml +
            sellingPlanHtml +
            renderProperties(item.properties) +
            '<div class="drawer-item__bottom">' +
              '<quantity-selector class="quantity-wrapper">' +
                '<label class="visually-hidden" for="drawer-quantity-' + (index + 1) + '">' + escapeHtml(quantityLabel) + '</label>' +
                '<div class="quantity-selector" role="group" aria-label="' + escapeAttr(quantityLabel) + '">' +
                  '<button type="button" class="quantity-selector__btn quantity-selector__btn--minus" aria-label="' + escapeAttr(decreaseLabel) + '" data-quantity-minus data-item-key="' + escapeAttr(item.key) + '"' + (item.quantity <= 1 ? ' aria-disabled="true"' : '') + '><span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /></svg></span></button>' +
                  '<input type="number" id="drawer-quantity-' + (index + 1) + '" name="updates[]" value="' + item.quantity + '" min="0" aria-label="' + escapeAttr(quantityLabel) + '" class="quantity-selector__input" data-quantity-input data-cart-item-key="' + escapeAttr(item.key) + '">' +
                  '<button type="button" class="quantity-selector__btn quantity-selector__btn--plus" aria-label="' + escapeAttr(increaseLabel) + '" data-quantity-plus data-item-key="' + escapeAttr(item.key) + '"><span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg></span></button>' +
                '</div>' +
              '</quantity-selector>' +
              '<div class="drawer-item__price-group">' +
                compareHtml +
                '<span class="' + priceClass + '" data-item-line-price>' + formatMoney(finalLinePrice, config) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }

    function renderEmptyState(config) {
      var template = document.querySelector('[data-cart-empty-template]');
      if (template) {
        return template.innerHTML;
      }
    }

    function renderBody(bodyEl, cart, config) {
      if (!bodyEl) return;
      bodyEl.scrollTop = 0;

      bodyEl.classList.toggle('cart-drawer__body--empty', cart.item_count === 0);

      if (!cart.item_count) {
        bodyEl.innerHTML = renderEmptyState(config);
        return;
      }
      var items = (cart.items || []).map(function (item, i) {
        return renderCartItem(item, i, config);
      }).join('');
      bodyEl.innerHTML =
        '<ul class="cart-drawer__items list-unstyled" id="cart-drawer-items" aria-label="' + escapeAttr(config.itemsLabel || 'Items') + '" data-cart-items>' +
          items +
        '</ul>';
    }

    function syncFooter(els, cart, config) {
      if (els.footer) {
        els.footer.classList.toggle('cart-drawer__footer--hidden', cart.item_count === 0);
      }
      if (els.subtotal) {
        els.subtotal.textContent = formatMoney(cart.total_price, config, true);
      }
      if (els.discountsWrapper && els.discountsList) {
        var discounts = config.showDiscounts ? (cart.cart_level_discount_applications || []) : [];
        var iconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6.5 7.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3" /></svg>';
        els.discountsList.innerHTML = discounts.map(function (discount) {
          var amount = discount.total_allocated_amount || 0;
          return (
            '<li class="cart-drawer__discount">' +
              iconSvg +
              '<span>' + escapeHtml(discount.heading || '') + '</span>' +
              '<span class="cart-drawer__discount-amount">-' + formatMoney(amount, config) + '</span>' +
            '</li>'
          );
        }).join('');
        els.discountsWrapper.hidden = discounts.length === 0;
      }
    }

    function syncShippingBar(els, cart, config) {
      if (!els.shippingBar || !els.shippingMessage || !els.shippingFill) return;      
      if (cart.item_count === 0) {
        els.shippingBar.hidden = true;
        return;
      }
      
      els.shippingBar.hidden = false;      
      var threshold = parseInt(els.shippingBar.dataset.threshold || '0', 10);
      if (!threshold) return;

      var totalPrice = cart.total_price || 0;
      var remaining  = Math.max(0, threshold - totalPrice);
      var progress   = Math.min(100, Math.round((totalPrice * 100) / threshold));

      els.shippingMessage.textContent = remaining > 0
        ? tmpl(config.freeShippingRemainingTemplate, formatMoney(remaining, config))
        : (config.freeShippingAchieved || '');

      els.shippingFill.style.width = progress + '%';
      els.shippingFill.classList.toggle('shipping-bar__fill--complete', progress >= 100);
    }

    function setItemLoading(drawerEl, key, on) {
      var item = drawerEl.querySelector('[data-item-key="' + key + '"]');
      if (!item) return;
      item.classList.toggle('drawer-item--loading', on);
      item.querySelectorAll('.quantity-selector__btn, [data-cart-remove]').forEach(function (btn) {
        btn.disabled = on;
      });
    }

    function cacheElements(drawerEl) {
      return {
        panel:            drawerEl.querySelector('[data-cart-drawer-panel]'),
        overlay:          drawerEl.querySelector('[data-cart-drawer-overlay]'),
        body:             drawerEl.querySelector('[data-cart-drawer-body]'),
        footer:           drawerEl.querySelector('[data-cart-footer]'),
        shippingBar:      drawerEl.querySelector('[data-shipping-bar]'),
        shippingMessage:  drawerEl.querySelector('[data-shipping-bar-message]'),
        shippingFill:     drawerEl.querySelector('[data-shipping-bar-fill]'),
        subtotal:         drawerEl.querySelector('[data-cart-subtotal]'),
        discountsWrapper: drawerEl.querySelector('[data-cart-discounts-wrapper]'),
        discountsList:    drawerEl.querySelector('[data-cart-discounts-list]'),
      };
    }

    async function updateCartItem(key, quantity, drawerEl, state) {
      if (!key) return;
      setItemLoading(drawerEl, key, true);

      var controller = new AbortController();
      state.activeControllers[key] = controller;

      try {
        var res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
          signal: controller.signal,
        });

        delete state.activeControllers[key];
        if (!res.ok) throw new Error('Cart change failed');

        await res.json();
        var cartRes = await fetch(window.Shopify.routes.root + 'cart.js', {
          headers: { Accept: 'application/json' },
        });
        var cart = await cartRes.json();
        await refreshFromCart(cart, drawerEl, state);


      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error('[CartDrawer]', err);
        setItemLoading(drawerEl, key, false);
      }
    }

    function debouncedUpdate(key, quantity, drawerEl, state) {
      if (state.qtyTimers[key]) clearTimeout(state.qtyTimers[key]);
      if (state.activeControllers[key]) {
        state.activeControllers[key].abort();
        delete state.activeControllers[key];
      }
      state.qtyTimers[key] = setTimeout(function () {
        delete state.qtyTimers[key];
        updateCartItem(key, quantity, drawerEl, state);
      }, 50);
    }

    function bindCloseButtons(drawerEl, closeFn) {
      drawerEl.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
        if (btn.dataset.cartDrawerBound === 'true') return;
        btn.addEventListener('click', closeFn);
        btn.dataset.cartDrawerBound = 'true';
      });
    }

    function bindQuantitySelectors(bodyEl, drawerEl, state) {
      if (!bodyEl || bodyEl._qtyDelegated) return;
      bodyEl._qtyDelegated = true;

      bodyEl.addEventListener('click', function (e) {
        var minusBtn = e.target.closest('[data-quantity-minus]');
        var plusBtn  = e.target.closest('[data-quantity-plus]');

        if (minusBtn) {
          var key   = minusBtn.dataset.itemKey;
          var input = minusBtn.closest('.quantity-selector') && minusBtn.closest('.quantity-selector').querySelector('[data-quantity-input]');
          if (!input || !key) return;
          var newVal = Math.max(0, parseInt(input.value, 10) - 1);
          input.value = newVal;
          debouncedUpdate(key, newVal, drawerEl, state);
        }

        if (plusBtn) {
          var key2   = plusBtn.dataset.itemKey;
          var input2 = plusBtn.closest('.quantity-selector') && plusBtn.closest('.quantity-selector').querySelector('[data-quantity-input]');
          if (!input2 || !key2) return;
          var newVal2 = parseInt(input2.value, 10) + 1;
          input2.value = newVal2;
          debouncedUpdate(key2, newVal2, drawerEl, state);
        }
      });

      bodyEl.addEventListener('change', function (e) {
        var input = e.target.closest('[data-quantity-input]');
        if (!input) return;
        var key    = input.dataset.cartItemKey;
        var newVal = Math.max(0, parseInt(input.value, 10) || 0);
        input.value = newVal;
        debouncedUpdate(key, newVal, drawerEl, state);
      });
    }

    function bindRemoveButtons(bodyEl, drawerEl, state) {
      if (!bodyEl || bodyEl._removeDelegated) return;
      bodyEl._removeDelegated = true;

      bodyEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cart-remove]');
        if (!btn) return;
        var key = btn.dataset.itemKey;
        if (key) updateCartItem(key, 0, drawerEl, state);
      });
    }

    function bindDiscountInput(drawerEl, state) {
      var btn = drawerEl.querySelector('[data-cart-discount-apply]');
      var input = drawerEl.querySelector('[data-cart-discount-input]');
      var errorEl = drawerEl.querySelector('[data-cart-discount-error]');
      if (!btn || !input || btn._discountBound) return;
      btn._discountBound = true;

      btn.addEventListener('click', async function () {
        var code = input.value.trim();
        if (!code) return;

        try {
          var res = await fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code), {
            method: 'GET',
            headers: { Accept: 'application/json' },
          });

          if (res.ok) {
            var cartRes = await fetch(window.Shopify.routes.root + 'cart.js', {
              headers: { Accept: 'application/json' },
            });
            var cart = await cartRes.json();
            input.value = '';
            errorEl.hidden = true;
            await refreshFromCart(cart, drawerEl, state);
          } else {
            errorEl.textContent = 'Invalid discount code.';
            errorEl.hidden = false;
          }
        } catch (err) {
          console.error('[CartDrawer discount]', err);
        }
      });
    }

    function bindDynamicEvents(drawerEl, closeFn, state) {
      bindCloseButtons(drawerEl, closeFn);
      var body = drawerEl.querySelector('[data-cart-drawer-body]');
      bindQuantitySelectors(body, drawerEl, state);
      bindRemoveButtons(body, drawerEl, state);
      bindDiscountInput(drawerEl, state);
    }

    function openDrawer(drawerEl, onKeydown, state) {
      drawerEl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      document.addEventListener('keydown', onKeydown);
      var panel = drawerEl.querySelector('[data-cart-drawer-panel]');
      requestAnimationFrame(function () { panel && panel.focus(); });
      document.body.style.overflow = 'hidden';

      fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return refreshFromCart(cart, drawerEl, state); })
        .catch(function (err) { console.error('[CartDrawer open]', err); });
    }

    function closeDrawer(drawerEl, onKeydown) {
      drawerEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      document.removeEventListener('keydown', onKeydown);
      var toggle = document.querySelector('[data-cart-toggle]');
      if (toggle) toggle.focus();
      document.body.style.overflow = '';
    }

    async function refreshFromCart(cart, drawerEl, state) {
      var count = cart.item_count;

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        if (el.classList) el.classList.toggle('cart-count--hidden', count === 0);
      });
      document.querySelectorAll('[data-cart-count-label]').forEach(function (el) {
        el.textContent = '(' + count + ')';
      });

      var els = cacheElements(drawerEl);

      await enrichCartItemsWithCompareAt(cart, state);

      renderBody(els.body, cart, state.config);
      syncFooter(els, cart, state.config);
      syncShippingBar(els, cart, state.config);

      bindDynamicEvents(drawerEl, state.closeFn, state);
    }

    function initCartDrawer() {
      var drawerEl = document.getElementById('cart-drawer');
      if (!drawerEl) return;

      var config = readConfig();

      var state = {
        config:            config,
        qtyTimers:         {},
        activeControllers: {},
        variantCache:      {},
        closeFn:           null,
      };

      function onKeydown(e) {
        if (e.key === 'Escape') state.closeFn();
      }

      function open()  { openDrawer(drawerEl, onKeydown, state); }
      function close() { closeDrawer(drawerEl, onKeydown); }

      state.closeFn = close;

      var overlay = drawerEl.querySelector('[data-cart-drawer-overlay]');
      if (overlay) overlay.addEventListener('click', close);

      document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
        if (btn.dataset.cartDrawerBound === 'true') return;
        btn.addEventListener('click', open);
        btn.dataset.cartDrawerBound = 'true';
      });

      drawerEl.querySelectorAll('.cart-drawer__accordion-trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          var bodyId   = trigger.getAttribute('aria-controls');
          var body     = document.getElementById(bodyId);

          trigger.setAttribute('aria-expanded', String(!expanded));
          if (body) body.setAttribute('aria-hidden', String(expanded));
        });
      });

      bindDynamicEvents(drawerEl, close, state);

      drawerEl.open = open;
      drawerEl.close = close;

      drawerEl.refresh = function (cart) {
        return refreshFromCart(cart, drawerEl, state);
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawer);
    } else {
      initCartDrawer();
    }

  })();